import React from 'react'
import {SVGButton} from '/app/src/component'

export default class HeaderArrow extends React.Component {
    render() {
        let{direction, src, size, ...rest} = this.props

        switch(direction){
            case 'right':
                src='/images/ArrowRight_S.svg'
                break;
            case 'up':
                src='/images/ArrowUp_S.svg'
                break;
            case 'down':
                src='/images/ArrowDown_S.svg'
                break;
            case 'left':
            default:
                src='/images/ArrowLeft_S.svg'
        }
        let transform;
        switch(size){
            case 'xsmall':
                transform='scale(0.5)'
                break;
            case 'small':
                transform='scale(0.7)'
                break;
            default:
                transform='scale(1)'
        }
        return (
            <SVGButton src={src} transform={transform} {...rest} maxHeight='40px'/>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/Arrow.js